import ReferenceData from "../constants/ReferenceData";
import { executeGet } from "../utils/apiUtils";

export const callLogoutSvc = () => {
    const callLogoutSvcResult = (response) => {
        return response;
    };

    const url = __baseApiUrl__ + ReferenceData.LOGOUT_SVC_URL;

    return executeGet(url, "callLogoutSvcFault", {})
        .then(callLogoutSvcResult)
        .catch((err) => {
            return err;
        });
};
